<template>
  <modal :show="show" @close="close">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Add Adjustment</modal-header>
    </div>
    <div>
      <form-group>
        <dropdown v-if="adjustment" :name="adjustmentType.name" :options="adjustmentType.options" current="credit"
                  v-model="adjustment.type"/>
      </form-group>
      <div class="form-group">
        <label class="control-label required" for="amount">Amount</label>
        <input type="number" id="amount" name="amount" required="required" class="form-control" value="0"
               v-model="adjustment.amount">
      </div>
      <div class="form-group">
        <label class="control-label required" for="note">Note</label>
        <textarea type="number" id="note" name="note" required="required" class="form-control"
                  v-model="adjustment.reason"></textarea>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="savePost"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'

import {invoiceMixin} from '@/mixins/invoiceMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_add_adjustment',
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Dropdown
  },
  mixins: [invoiceMixin, modalMixin, notificationMixin],
  props: {
    show: Boolean,
    field: String,
    adjustmentId: [Number, String]
  },
  data: () => ({
    amount: 0,
    note: '',
    adjustmentType: {
      id: 'Type',
      name: 'Type',
      value: 'credit',
      options: [
        {
          name: 'Credit',
          value: 'credit'
        },
        {
          name: 'Charge',
          value: 'charge'
        }
      ]
    }
  }),
  mounted () {},
  computed: {
    id () {
      return this.$route.params.id
    },
    adjustment () {
      return {
        type: 'charge',
        amount: '',
        reason: ''
      }
    }
  },
  methods: {
    savePost () {
      this.startLoading()
      this.adjustment.invoice = this.id
      this.addSingleAdjustment(this.adjustment).then(() => {
        this.getSingleInvoice(this.id).then(() => {
          this.addNotification('success', 'A new adjustment has been added.')
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/invoices/modal-add-adjustment.vue